import type { MouseEvent } from 'react'
import {
  SimulationCopyBasis,
  copiedFromLabel,
  copyBasisSentence,
  type CopiedFrom,
} from '../lib/simulationCopy.ts'

/**
 * Says that a simulation is a copy, and of which conferência (#586).
 *
 * A copy looks like any other conferência once it is analysed, and what it
 * shows is only worth reading beside the original. A copy taken from the ERP
 * as it is now is said in the warning's colours: the pharmacy may have changed
 * the orçamento since, so it may not be the case somebody set out to reproduce.
 */
export interface CopiedFromNoticeProps {
  readonly from: CopiedFrom
  /** The original's address, and what following it does. Absent: no link. */
  readonly originalHref?: string | undefined
  readonly onOpenOriginal?: ((event: MouseEvent<HTMLAnchorElement>) => void) | undefined
}

export function CopiedFromNotice({ from, originalHref, onOpenOriginal }: CopiedFromNoticeProps) {
  const current = from.basis === SimulationCopyBasis.CurrentErp
  return (
    <div
      role="status"
      className={`rounded-base text-tP text-text-strong flex flex-wrap items-center gap-x-3 gap-y-1 border p-3 ${
        current
          ? 'border-stroke-warning-weak bg-fill-warning-weak'
          : 'border-stroke-brand-strong bg-fill-brand-weak/20'
      }`}
    >
      <span className="text-tTiny text-text-weak font-semibold uppercase">Cópia</span>
      <span>
        Cópia da conferência{' '}
        {originalHref === undefined || from.verificationId === null ? (
          <strong>{copiedFromLabel(from)}</strong>
        ) : (
          <a
            className="text-text-brand font-semibold underline"
            href={originalHref}
            target="_blank"
            rel="noreferrer"
            onClick={onOpenOriginal}
          >
            {copiedFromLabel(from)}
          </a>
        )}{' '}
        · {from.accountName}
      </span>
      <span className="text-tSmall text-text-weak basis-full">
        {copyBasisSentence(from.basis, from.answeredAt)} Copiada por {from.copiedBy}.
      </span>
    </div>
  )
}
